import createSvgIcon from "./utils/create_icon"

const Restart = createSvgIcon(<path d="M12 4.08a1 1 0 0 0-1.625-.78L7.976 5.22a1 1 0 0 0 0 1.56l2.4 1.92A1 1 0 0 0 12 7.92V7a6 6 0 1 1-6 6 1 1 0 1 0-2 0 8 8 0 1 0 8-8v-.92z" fill="currentColor" />, "Restart")
export default Restart
